import React from "react";

const Button = ({ as = "button", className = "", children, ...delegated }) => {
  const TagName = as;

  return (
    <TagName className={`cross-sell-button ${className}`} {...delegated}>
      {children}
    </TagName>
  );
};

export { Button };
